export enum CategoryEnum {
    cheeseCake = 1,
    chockolateCate = 2,
    uniqueCake = 3,
    birthdayCake = 4,
};

export const CategoryConsts = {
    [CategoryEnum.cheeseCake]: "עוגות גבינה",
    [CategoryEnum.chockolateCate]: "עוגות שוקולד",
    [CategoryEnum.uniqueCake]: "עוגות מיוחדות",
    [CategoryEnum.birthdayCake]: "עוגות יום הולדת",
}